import vueVimeoPlayer from 'vue-vimeo-player'
import Vue from 'vue'

Vue.use(vueVimeoPlayer)